// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__31MtB","rootSmall":"AddTileButton_rootSmall__21WDp"};